import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { PersonService } from '../../../../service/person.service';
import { Store } from '@ngrx/store';
import { MedicationGridObject } from '@it2go/types';
import { NursingCareService } from '../../../../../../services/nursing-care.service';

interface State {
    medications: MedicationGridObject | null;
}

const defaultState: State = {
    medications: null,
};

@Injectable()
export class VoucherDetailSituationOrpStore extends ComponentStoreFactory<
    State,
    PersonService
> {

    public readonly nursingCareSvc = inject(NursingCareService);
    constructor() {
        super(defaultState, inject(Store), inject(PersonService), inject(NursingCareService));
    }
}
